import React from 'react';
import nevo from '../../assets/external-logos/nevo-akademya-254.png';
import takdin from '../../assets/external-logos/takdin_1.png';
import topocad from '../../assets/external-logos/topocad.png';
import govIl from '../../assets/external-logos/logo_gov_il_1.png';
import mavat from '../../assets/external-logos/mavat.png';
import nta from '../../assets/external-logos/nta.png';
import yad2 from '../../assets/external-logos/yad2.png';
import madlan from '../../assets/external-logos/madlan.svg';
import styles from './styles.module.scss';

const externalLinks = [
  {
    id: 1,
    title: 'נבו',
    href: 'https://www.nevo.co.il/',
    icon: nevo,
  },
  {
    id: 2,
    title: 'תקדין',
    href: 'https://www.takdin.co.il/',
    icon: takdin,
  },
  {
    id: 3,
    title: 'טופוקד',
    href: 'https://www.topocad.gov.il/home',
    icon: topocad,
  },
  {
    id: 4,
    title: 'שומות מכריעות',
    href: 'https://www.gov.il/he/Departments/DynamicCollectors/decisive_appraisal_decisions?skip=0',
    icon: govIl,
  },
  {
    id: 5,
    title: 'רשות מקרקעי ישראל',
    href: 'https://www.gov.il/he/departments/israel_land_authority/govil-landing-page',
    icon: govIl,
  },
  {
    id: 6,
    title: 'המרכז למיפוי ישראל',
    href: 'https://www.gov.il/he/departments/survey_of_israel/govil-landing-page',
    icon: govIl,
  },
  {
    id: 7,
    title: 'אתר מנהל התכנון',
    href: 'https://mavat.iplan.gov.il/SV1',
    icon: mavat,
  },
  {
    id: 8,
    title: 'נת"ע',
    href: 'https://www.nta.co.il/',
    icon: nta,
  },
  {
    id: 9,
    title: 'יד 2',
    href: 'https://www.yad2.co.il/',
    icon: yad2,
  },
  {
    id: 10,
    title: 'מדלן',
    href: 'https://www.madlan.co.il/ ',
    icon: madlan,
  },
  {
    id: 11,
    title: 'איתור גוש חלקה לפי כתובת',
    href: 'https://www.gov.il/apps/mapi/parcel_address/parcel_address.html',
    icon: govIl,
  },
];

const ExternalLink = ({title, href, icon}) => {
  return (
    <a href={href} target="_blank" rel="noreferrer" className={styles.linkContainer}>
      <span className={styles.imageContainer}>
        <img src={icon} alt="icon" className={styles.image}/>
      </span>
      <span className={styles.title}>
        {title}
      </span>
    </a>
  );
};

const PopupExternalLinks = () => {
  const renderLinks = () => externalLinks.map(item => (
      <ExternalLink
        {...item}
        key={item.id}
      />
    )
  );

  return (
    <div className={styles.container}>
      {renderLinks()}
    </div>
  );
};

export default PopupExternalLinks;